import {
  base_colorSurface,
  cta_buttonPrimaryBackground,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.DowngradedToStarterModal .BaseModal-Body {
    border-radius: 10px;
  }

  .BaseModal-Content.interactive {
    width: 700px;
  }

  .DowngradedToStarterModal-body {
    position: relative;
    padding: ${spacing(15)};
  }

  .DowngradedToStarterModal-Corner-image {
    position: absolute;
    top: 0;
    right: 0;
  }

  .RoundCard {
    // overwrite background color style
    background-color: ${base_colorSurface};
    box-shadow: none;
    padding: ${spacing(5)};
  }

  // PLACEHOLDER
  .LinkText {
    color: ${cta_buttonPrimaryBackground};
    font-size: ${font_size_sm};
    line-height: 18px;
    font-weight: bold;
  }

  .AlertPanel-bolded {
    font-family: ${font_family_weight_medium};
  }
`
